<template>
  <component :is="iconComponent" :size="size"/>
</template>

<script>
// all icon that you need
import { CheckCircleIcon, ArrowRightIcon, PlusIcon, MinusIcon, MoreVerticalIcon, InfoIcon, GridIcon, UserIcon, SettingsIcon,MailIcon, GlobeIcon, CompassIcon, HeartIcon, LogOutIcon, EyeIcon, EyeOffIcon, CopyIcon, MessageSquareIcon, ChevronLeftIcon, ChevronRightIcon } from "vue-feather-icons";

export default {
  components: {
    CheckCircleIcon,
    MoreVerticalIcon,
    ArrowRightIcon,
    InfoIcon,
    GridIcon,
    UserIcon,
    SettingsIcon,
    MailIcon,
    PlusIcon, MinusIcon,
    GlobeIcon, CompassIcon, HeartIcon, LogOutIcon, EyeIcon, EyeOffIcon, CopyIcon, MessageSquareIcon,
    ChevronLeftIcon, ChevronRightIcon
    
  },
  props: {
    icon: [String, Array],
    size: String,
    customClass: String
  },
  computed: {
    iconComponent() {
      return this.icon[1] + "Icon";
    }
  }
};
</script>
